
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { renderExploreNetraa } from "../docs/apm/renderExploreNetraa";
import { renderPlatformCapabilities } from "../docs/apm/NetraaApmLanding.jsx";
import { renderNetraaAPM } from "../docs/apm/renderNetraaAPM";
import { renderGettingStarted } from "../docs/apm/renderGettingStarted.jsx";
import { renderQuickStart } from "../docs/apm/renderQuickStart";
import { renderPlatformOverview } from "../docs/apm/renderPlatformOverview";
import { rendercoreConcept } from "../docs/apm/rendercoreConcept";
import { renderoverview } from "../docs/apm/renderoverview";
import { renderGeneralServices } from "../docs/apm/renderGeneralServices";
import { renderinfraMonitoring } from "../docs/apm/renderinfraMonitoring";
import { renderDatabaseMonitoring } from "../docs/apm/renderDatabaseMonitoring";
import { renderbrowserMonitoring } from "../docs/apm/renderbrowserMonitoring";
import { RenderMsgMQ } from "../docs/apm/RenderMsgMQ";
import { renderAlert } from "../docs/apm/renderAlert";
import { renderreport } from "../docs/apm/renderreport";
import { renderanalytics } from "../docs/apm/renderanalytics";
import { renderintegration } from "../docs/apm/renderintegration";
import { renderServicenow } from "../docs/apm/renderServicenow.jsx";
import { renderPrerequisites } from "../docs/apm/renderPrerequisites.jsx";
import { renderMinimal } from "../docs/apm/renderMinimal";
import { renderagentsetup } from "../docs/apm/agentSetupGuide.jsx";
import { rendernetraaLH } from "../docs/netraaLH/rendernetraaLH";
import { renderDashboard } from "../docs/netraaLH/renderDashboard";
import { renderAvailability } from "../docs/netraaLH/renderAvailability";
import { renderErrorSLA } from "../docs/netraaLH/renderErrorSLA";
import { renderreportLH } from "../docs/netraaLH/renderreportLH";
import { rendernetraaLHConcepts } from "../docs/netraaLH/rendernetraaLHConcepts";
import { renderNetraaLHReleaseNotes } from "../docs/netraaLH/releaseNotes/renderNetraaLHReleaseNotes.jsx";
import { renderNetraaLHReleaseNotes1 } from "../docs/netraaLH/releaseNotes/renderNetraaLHReleaseNotes1.jsx";
import { renderNetraaLHReleaseNotes2 } from "../docs/netraaLH/releaseNotes/renderNetraaLHReleaseNotes2.jsx";
import { renderNetraaLHReleaseNotes3 } from "../docs/netraaLH/releaseNotes/renderNetraaLHReleaseNotes3.jsx";
import { renderNetraaLHReleaseNotes4 } from "../docs/netraaLH/releaseNotes/renderNetraaLHReleaseNotes4.jsx";
import { renderNetraaLHReleaseNotes5 } from "../docs/netraaLH/releaseNotes/renderNetraaLHReleaseNotes5.jsx";
import { renderNetraaLHReleaseNotes6 } from "../docs/netraaLH/releaseNotes/renderNetraaLHReleaseNotes6.jsx";
import { renderAiOverview } from "../docs/aiops/renderAiOverview";
import { renderAiopsDeploy } from "../docs/aiops/renderAiopsDeploy";
import { renderAiopsRag } from "../docs/aiops/renderAiopsRag.jsx";
import { renderAiopsCorrelation } from "../docs/aiops/renderAiopsCorrelation.jsx";
import { renderGenaiAiops } from "../docs/aiops/renderGenaiAiops.jsx";
import { renderPredictive } from "../docs/aiops/renderPredictive.jsx";
import { renderCausal } from "../docs/aiops/renderCausal.jsx";
import { renderAiopsIntegration } from "../docs/aiops/renderAiopsIntegration.jsx";
import { renderapps } from "../docs/apm/apps.jsx";
import { renderServices } from "../docs/apm/services.jsx";
import { renderHost } from "../docs/apm/host.jsx";
import { renderRedis } from "../docs/apm/renderRedis.jsx";
import { renderDatabase } from "../docs/apm/renderRelational.jsx";
import { renderAwsApiGatewayGuide } from "../docs/apm/renderAwsApiGatewayGuide.jsx";
import { renderNetraaRDSAgent } from "../docs/apm/renderNetraaRDSAgent.jsx";
import { renderNetraaEKSAgent } from "../docs/apm/renderNetraaEKSAgent.jsx";
import { renderNetraaVMsAgent } from "../docs/apm/renderNetraaVMsAgent.jsx";
import { renderKafkaMonitoring } from "../docs/apm/renderKafkaMonitoring.jsx";
import { renderInfraLinux } from "../docs/apm/renderInfraLinux.jsx";
import { renderWindowsMonitoringGuide } from "../docs/apm/renderWindowsMonitoringGuide.jsx";
import { renderJavaAgent } from "../docs/apm/renderJavaAgent.jsx";
import { renderPythonAgent } from "../docs/apm/renderPythonAgent.jsx";
import { renderNodejs } from "../docs/apm/renderNodejs.jsx";
import { renderDotnetAgent } from "../docs/apm/renderDotnetAgent.jsx";
import { renderPHP } from "../docs/apm/renderPHP.jsx";
import { renderNetraaMySQLAgent } from "../docs/apm/renderNetraaMySQLAgent.jsx";
import { renderNetraaMsSQLAgent } from "../docs/apm/renderNetraaMsSQLAgent.jsx";
import { renderOracleExporterSetup } from "../docs/apm/renderOracleExporterSetup.jsx";
import { renderNetwork } from "../docs/apm/renderNetwork.jsx";
import { renderActiveMQIntegration } from "../docs/apm/renderActiveMQIntegration.jsx";
import { renderNetraaAPMReleaseNotes } from "../docs/apm/releaseNotes/renderNetraaAPMReleaseNotes.jsx";
import { renderNetraaAPMReleaseNotes1 } from "../docs/apm/releaseNotes/renderNetraaAPMReleaseNotes1.jsx";
import { renderNetraaAPMReleaseNotes2 } from "../docs/apm/releaseNotes/renderNetraaAPMReleaseNotes2.jsx";
import { renderNetraaAPMReleaseNotes3 } from "../docs/apm/releaseNotes/renderNetraaAPMReleaseNotes3.jsx";
import { renderNetraaAPMReleaseNotes4 } from "../docs/apm/releaseNotes/renderNetraaAPMReleaseNotes4.jsx";
import { renderNetraaAPMReleaseNotes5 } from "../docs/apm/releaseNotes/renderNetraaAPMReleaseNotes5.jsx";
import { renderAdminOnboardingGuide } from "../docs/apm/renderAdminConfig.jsx";

export default function APMOfflineGuide({ activeSection, setActiveSection }) {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollToId) {
      const el = document.getElementById(location.state.scrollToId);
      if (el) {
        requestAnimationFrame(() => {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        });
      }
    }
  }, [location]);

  const sectionMap = {
    exploreNetraa: renderExploreNetraa,
    netraaApmLanding:renderPlatformCapabilities,
    netraaAPM: renderNetraaAPM,
    gettingStarted: renderGettingStarted,
    quickStart: renderQuickStart,
    platformOverview: renderPlatformOverview,
    coreConcept: rendercoreConcept,
    appOverview: renderoverview,
    generalServices: renderGeneralServices,
    infraMonitoring: renderinfraMonitoring,
    databaseMonitoring: renderDatabaseMonitoring,
    browserMonitoring: renderbrowserMonitoring,
    msgmq: RenderMsgMQ,
    alert: renderAlert,
    report: renderreport,
    analytics: renderanalytics,
    integration: renderintegration,
    servicenow: renderServicenow,
    apps: renderapps,
    homeservices: renderServices,
    infrahost: renderHost,
    infraredis: renderRedis,
    db: renderDatabase,
    configadmin: renderAdminOnboardingGuide,
    prerequisitesAPM: renderPrerequisites,
    agentsetup: renderagentsetup,
    agentawsgateway: renderAwsApiGatewayGuide,
    agentawsrds: renderNetraaRDSAgent,
    agentawseks: renderNetraaEKSAgent,
    agentazurevm: renderNetraaVMsAgent,
    agentkafka: renderKafkaMonitoring,
    agentlinux: renderInfraLinux,
    agentwindows: renderWindowsMonitoringGuide,
    agentjava: renderJavaAgent,
    agentpython: renderPythonAgent,
    agentnodejs: renderNodejs,
    agentdotnet: renderDotnetAgent,
    agentphp: renderPHP,
    agentmysql: renderNetraaMySQLAgent,
    agentmssql: renderNetraaMsSQLAgent,
    agentoracle: renderOracleExporterSetup,
    network: renderNetwork,
    activemq: renderActiveMQIntegration,
    Minimal: renderMinimal,
    AiOverview: renderAiOverview,
    AiopsSetup: renderAiopsDeploy,
    ragDoc: renderAiopsRag,
    correlation: renderAiopsCorrelation,
    genAi: renderGenaiAiops,
    predictiveModeling: renderPredictive,
    causalAi: renderCausal,
    AiOpsintegration: renderAiopsIntegration,
    netraaLH: rendernetraaLH,
    Dashboard: renderDashboard,
    Availability: renderAvailability,
    ErrorSLA: renderErrorSLA,
    reportLH: renderreportLH,
    netraaLHConcepts: rendernetraaLHConcepts,
    "releaseNotesv1.5": renderNetraaLHReleaseNotes,
    "releaseNotesv1.4": renderNetraaLHReleaseNotes1,
    "releaseNotesv1.3": renderNetraaLHReleaseNotes2,
    "releaseNotesv1.2": renderNetraaLHReleaseNotes3,
    "releaseNotesv1.1": renderNetraaLHReleaseNotes4,
    "releaseNotesv1.0": renderNetraaLHReleaseNotes5,
    "releaseNotesv1.6": renderNetraaLHReleaseNotes6,
    releasenotesAPM: renderNetraaAPMReleaseNotes,
    releasenotesAPMv2: renderNetraaAPMReleaseNotes1,
    releasenotesAPMv3: renderNetraaAPMReleaseNotes2,
    releasenotesAPMv4: renderNetraaAPMReleaseNotes3,
    releasenotesAPMv5: renderNetraaAPMReleaseNotes4,
    releasenotesAPMv6: renderNetraaAPMReleaseNotes5,
  };

  const renderFn = sectionMap[activeSection || ""];

  return (
    <div className="print-content text-text-main dark:text-white">
      {renderFn ? renderFn() : null}
    </div>
  );
}